import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import axios from 'axios'
import DocModal from './SmallComponents/DocModal'
import PollQuestion from './SmallComponents/PollQuestion'
import config from '../../config'
import UpdatesCard from './SmallComponents/UpdatesCard'
import DocumentCard from './SmallComponents/DocumentCard'
import FormRenderCard from './SmallComponents/FormRenderCard'

const Updates = () => {
  const [posts, setPosts] = useState([])
  const wideBlockRef = useRef()

 
  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 130
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }
    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  
  useEffect(() => {
    fetchAndEnrichPosts()
  }, [])

  const fetchAndEnrichPosts = async () => {
    const token = localStorage.getItem('token')
    try {
      
      const res = await axios.get(`${config.apiUrl}/post/getAll`, {
        headers: { Authorization: token }
      })
      let allPosts = res.data?.data || [];

      allPosts = allPosts.map(post => {
        if (
          post.Type === 'Form' &&
          post.Data?.FormID &&
          (!post.Data?.fields || post.Data.fields.length === 0)
        ) {
          return {
            ...post,
            Data: {
              ...post.Data,
              // ...formMap[post.Data.FormID]
            }
          }
        }
        return post
      })

      
      // const incompleteForms = allPosts.filter(
      //   item =>
      //     item.Type === 'Form' &&
      //     item.Data?.FormID &&
      //     (!item.Data?.fields || item.Data.fields.length === 0)
      // )

      // if (incompleteForms.length > 0) {
      //   try {
      //     const formRes = await axios.get(`${config.apiUrl}/post/Form`, {
      //       headers: { Authorization: token }
      //     })
      //     const fullForms = formRes.data?.data || []

          
      //     const formMap = {}
      //     fullForms.forEach(form => {
      //       if (form.Data?.FormID) {
      //         formMap[form.Data.FormID] = form.Data
      //       }
      //     })

         
      //     allPosts = allPosts.map(post => {
      //       if (
      //         post.Type === 'Form' &&
      //         post.Data?.FormID &&
      //         (!post.Data?.fields || post.Data.fields.length === 0) &&
      //         formMap[post.Data.FormID]
      //       ) {
      //         return {
      //           ...post,
      //           Data: {
      //             ...post.Data,
      //             ...formMap[post.Data.FormID] 
      //           }
      //         }
      //       }
      //       return post
      //     })
      //   } catch (formErr) {
      //     console.warn('Failed to enrich forms from /post/Form', formErr)
          
      //   }
      // }

     console.log({allPosts});
      allPosts.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn))

      setPosts(allPosts)
    } catch (err) {
      console.error('Failed to fetch posts', err)
    }
  }

  
  const formatDate = dateStr => {
    const d = new Date(dateStr)
    return {
      date: d.toLocaleDateString('en-GB'),
      time: d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }
  }

  return (
    <div id="appCapsule">
      <div className="section full mt-1">
        <div className="wide-block mt-1" ref={wideBlockRef}>
          <div className="timeline timed">
            {posts.map(item => {
              const { date, time } = formatDate(item.CreatedOn)
              return (
                <div className="item" key={item.ID}>
                  <span className="time">
                    {date} <br /> {time}
                  </span>

                  <div
                    className={`dot ${
                      item.Type === 'Updates'
                        ? 'bg-danger'
                        : item.Type === 'Vote'
                        ? 'bg-warning'
                        : item.Type === 'Document'
                        ? 'bg-black'
                        : 'bg-info'
                    }`}
                  ></div>

                  <div className="content">
                   
                    {item.Type === 'Document' && (
                      <div className="card p-3">
                        <DocumentCard item={item} />
                      </div>
                    )}

                    
                    {item.Type === 'Updates' && (
                       <div className="card p-3">
                         <UpdatesCard item={item} />
                       </div>
                    )}

                  
                    {item.Type === 'Vote' && (
                      <div className="card p-3" style={{ backgroundColor: '#f1f1f1' }}>
                        <PollQuestion
                          pollID={item.ID}
                          question={item.Data?.Question?.trim() || 'Untitled Poll'}
                          options={(item.Data?.Options || [])
                            .filter(Boolean)
                            .map((opt, index) => ({
                              optionId: index,
                              label: opt,
                              votes: item.Data?.Submissions?.[opt] ?? 0
                            }))}
                          MySubmission={item?.MySubmission?.Data?.SelectedOption ?? null}
                          onVoteSuccess={fetchAndEnrichPosts}
                        />
                      </div>
                    )}

                    
                    {item.Type === 'Form' && (
                      <div className="card p-3" style={{ backgroundColor: '#f1f1f1' }}>
                        <FormRenderCard item={item} reloadList={fetchAndEnrichPosts} />
                      </div>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Updates